"use client";

import { usePathname } from "next/navigation";
import { ReactNode } from "react";

interface LayoutWrapperProps {
  children: ReactNode;
  tenant?: {
    slug?: string;
    footerTransparentOnHomepage?: boolean;
    homepageBackgroundImage?: string | null;
  } | null;
}

/**
 * LayoutWrapper handles page-level background styling.
 * When on the homepage with footerTransparentOnHomepage enabled and a
 * homepageBackgroundImage set, the background extends behind both
 * the main content and the footer.
 */
export function LayoutWrapper({ children, tenant }: LayoutWrapperProps) {
  const pathname = usePathname();

  // Check if we're on the homepage (only root "/", not tenant pages like /inspire)
  const isHomepage = pathname === '/';

  // Apply homepage background when transparent footer is enabled
  const useHomepageBackground = isHomepage && tenant?.footerTransparentOnHomepage && tenant?.homepageBackgroundImage;

  return (
    <div
      className="min-h-screen flex flex-col"
      style={useHomepageBackground ? {
        backgroundImage: `url('${tenant.homepageBackgroundImage}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      } : {
        backgroundColor: '#F9FAFB',
      }}
    >
      {children}
    </div>
  );
}
